import FlashLib from 'flashlib_onlyplay';
import EntryPoint from 'Engine/EntryPoint';
import eGameMode from '../enums/eGameMode';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import eEventTypes from '../enums/eEventTypes';

export default class ControllerSlot extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    this.init();
    // this.mode = EntryPoint.GameModel.isFreeSpinsMode ? eGameMode.EGM_BONUS : eGameMode.EGM_REGULAR;
    this.addListeners();
  }

  init() {
    const slotContainer = this.getChildByName('slotContainer');
    this.reelsContainer = slotContainer.getChildByName('reelsContainer');

    this.background = slotContainer.getChildByName('background');
    this.frontalContainer = slotContainer.getChildByName('slotFront');
    this.reelsContainer.initFeaturesController(this.frontalContainer);
  }

  addListeners() {
    // GlobalDispatcher.add(eEventTypes.EET_FREESPINS_START__SHOWN_UP, this.toggleMode, this);
    // GlobalDispatcher.add(eEventTypes.EET_FREESPINS_END__SHOWN_UP, this.toggleMode, this);
    GlobalDispatcher.add(eEventTypes.EET_WINNINGS_CONTROLLER__SLOW_WIN, this.showWin, this);
    GlobalDispatcher.add(eEventTypes.EET_WINNINGS_CONTROLLER__START_WINNINGS, this.startWinnings, this);
  }

  toggleMode = () => {
    this.mode = EntryPoint.GameModel.freespinsEnabled ? eGameMode.EGM_BONUS : eGameMode.EGM_REGULAR;
  };

  start() {
    this.background.playWaitAnimation();
    this.reelsContainer.start();
  }

  stop() {
    const data = EntryPoint.GameModel.reels;
    this.reelsContainer.stop(data);
  }

  startWinnings(data) {
    this.background.playWinAnimation();
    this.reelsContainer.startWinnings(data);
  }

  showWin(data) {
    this.reelsContainer.showWin(data);
  }

  get willShowBonusStartAnimation() {
    return this.reelsContainer.willShowScattersAnimation;
  }

  set mode(mode) {
    this._mode = mode;
    this.reelsContainer.swapReels(mode);
    this.background.mode = mode;
  }
}
